import React, { useEffect } from 'react'
import AnnouncementsList from './AnnouncementsList'
import AddAnnouncements from './AddAnnouncements'
import UpgradePopup from './UpgradePopup';
import { Button, Modal } from 'react-bootstrap';
import { useState } from 'react';
import { getAnnouncementDetails } from '../../../../../../actions/appsMoreAction';
import { TOAST_LOADING, resturctureCloudPath } from '../../../../../../utils';
import { shallowEqual, useSelector } from 'react-redux';
import { UPLOAD_URL } from '../../../../../../actions/api';
import { FontAwesomeIcon } from '../../../../../CommonComponents/AssetsHelper';

function Announcements({ onHide, show, details }) {
    const [isLoading, setIsLoading] = useState(false)
    const [announcementsListData, setAnnouncementsListData] = useState([])
    const [announcementsStatus, setAnnouncementsStatus] = useState(0)
    const [itemIndex, setItemIndex] = useState()
    const { userData } = useSelector((state) => state.authenticated, shallowEqual);

    useEffect(() => {
        getAnnouncementDetails().then(response => {
            const { responseCode, responseData, responseStatus } = response.data;
            TOAST_LOADING();
            if (responseCode == 200) {
                setIsLoading(true);
                let announcementsList = responseData;
                if(responseData && responseData.length > 0){
                    announcementsList = responseData.map(announcement => ({
                        ...announcement, mediaFile : resturctureCloudPath(announcement.mediaFile, UPLOAD_URL)
                    }))
                }
                setAnnouncementsListData(announcementsList)
            }
        })
    }, [])

    return (
        isLoading ? <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
        >
            {userData?.UserRule?.screenAnnoncements == 1 ? <div className="modal-content">
                <div className="modal-header justify-content-between">
                    <h4 className="modal-title">{!announcementsStatus && announcementsListData && announcementsListData.length ? `Announcements` : `${announcementsStatus === 1 ? `Add` : announcementsStatus === 2 ? `Edit` : `Add`} Announcement`}</h4>
                    <Button variant="link" className="px-2" onClick={onHide} data-bs-dismiss="modal" aria-label="Close" aria-hidden="true">
                        <FontAwesomeIcon type={'regular'} icon={'xmark'} iconClass={'text-secondary fs-6'} />
                    </Button>
                </div>
                {!announcementsStatus && announcementsListData && announcementsListData.length ? <AnnouncementsList announcementsListData={announcementsListData} announcementsStatus={setAnnouncementsStatus} setItemIndex={setItemIndex} onHide={onHide} /> :
                    <AddAnnouncements details={details} announcementsListData={announcementsListData} announcementsStatus={announcementsStatus} itemIndex={itemIndex} onHide={onHide} />}
            </div> : <UpgradePopup onHide={onHide} />}
        </Modal > : null
    )
}

export default Announcements